<template>
  <div class="stepper-content">
    <span>こちらの内容でVNコネクトを設定します。よろしいですか？</span>
    <div v-if="form.siteInfo && form.vpnVnCodeInfo" class="mt-3">
      <!-- サイト名 -->
      <v-row>
        <v-col>
          <app-label-group label="サイト名">
            <template #value>
              <div class="ml-3">
                <span>
                  {{ form.siteInfo.enumber }}:{{
                    form.siteInfo.siteName
                  }}(<template
                    v-if="form.siteInfo.vlanIdType === 'SPECIFIED'"
                    >{{ form.siteInfo.vlanId }}</template
                  ><template v-else>{{
                    $filter.enumTo(form.siteInfo.vlanIdType, "vlanIdType")
                  }}</template
                  >)
                </span>
              </div>
            </template>
          </app-label-group>
        </v-col>
      </v-row>
      <!-- 接続先仮想ネットワーク（VPN/VN）名 -->
      <v-row>
        <v-col
          ><app-label-group label="接続先仮想ネットワーク(VPN/VN)名">
            <template #value>
              <div class="ml-3">
                <span v-if="form.vpnVnCodeInfo.vnName">
                  {{ form.vpnVnCodeInfo.vnName }}({{
                    form.vpnVnCodeInfo.vpnVnCode
                  }}:{{ form.vpnVnCodeInfo.vnType }})
                </span>
                <span v-else>
                  {{ form.vpnVnCodeInfo.vpnVnCode }}
                </span>
              </div>
            </template>
          </app-label-group>
        </v-col>
      </v-row>
      <!-- VNコネクト名 -->
      <v-row>
        <v-col>
          <app-label-group label="VNコネクト名" :value="form.vnConnectName" />
        </v-col>
      </v-row>
      <!-- ペア回線 -->
      <v-row v-if="isShowPairLine">
        <v-col>
          <app-label-group
            label="ペア回線"
            :value="$filter.emptyTo(form.pairLine, '-')"
          />
        </v-col>
      </v-row>
      <!-- 品目 -->
      <v-row>
        <v-col
          ><app-label-group label="品目">
            <template #value>
              <div class="ml-3">
                <span v-if="form.bandwidthType === 'BURST'">
                  バースト
                  <template v-if="form.siteInfo.lineBandwidth">
                    <template
                      v-if="
                        form.siteInfo.lineBandwidth.bandwidthType === 'BURST10'
                      "
                      >(バースト10)</template
                    >
                    <template
                      v-else-if="
                        form.siteInfo.lineBandwidth.bandwidthType === 'BURST100'
                      "
                      >(バースト100)</template
                    >
                  </template>
                </span>
                <span v-else>
                  {{ $filter.enumTo(form.bandwidthType, "vnConBandwidthType") }}
                  <span v-if="isShowBandwidth && form.bandwidth">
                    ({{ form.bandwidth.value
                    }}{{
                      $filter.enumTo(form.bandwidth.unit, "bandwidth_unit")
                    }})
                  </span>
                </span>
              </div>
            </template>
          </app-label-group>
        </v-col>
      </v-row>
      <!-- L2VNの場合 -->
      <template v-if="form.vpnVnCodeInfo.vnType === 'L2'">
        <!-- VLAN制御 -->
        <!-- 表示：契約変更が可能 & 選択した回線のVLAN制御が「ON」 & サイトをUntagで作成している場合 -->
        <v-row>
          <v-col>
            <app-label-group
              v-if="
                form.siteInfo.lineBandwidth &&
                form.siteInfo.lineBandwidth.vlanControl === 'ON' &&
                form.siteInfo.vlanIdType === 'UNTAG'
              "
              label="VLAN制御"
              :value="$filter.enumTo(form.l2?.isVlanControl, 'on_off')"
            />
          </v-col>
        </v-row>
        <template v-if="isShowQos">
          <!-- QoS設定 -->
          <v-row>
            <v-col>
              <app-label-group
                label="QoS設定"
                :value="
                  form.qos ? $filter.enumTo(form.qos?.isQoS, 'on_off') : '-'
                "
              />
            </v-col>
          </v-row>
          <!-- 割当帯域パターン -->
          <v-row>
            <v-col>
              <app-label-group
                v-if="form.qos?.isQoS && qos.qosType === 'BANDWIDTH'"
                label="割当帯域パターン"
                :value="
                  $filter.enumTo(
                    form.qos.qosBandControlPattern,
                    'vnConControlPattern'
                  )
                "
              />
            </v-col>
          </v-row>
        </template>
      </template>

      <!-- L3VPN/L3VNの場合 -->
      <template v-else>
        <!-- ルーティング種別 -->
        <v-row>
          <v-col>
            <app-label-group
              label="ルーティング種別"
              :value="form.l3?.routingType === 'STATIC' ? 'Static' : 'BGP4'"
            />
          </v-col>
        </v-row>
        <!-- WANアドレス -->
        <v-row>
          <v-col>
            <app-label-group label="WANアドレス" :value="form.l3?.wanAddress" />
          </v-col>
        </v-row>
        <!-- ルーティング種別がBGP4の場合 その1 -->
        <template v-if="form.l3?.routingType === 'BGP4'">
          <!-- ピアIPアドレス -->
          <v-row>
            <v-col>
              <app-label-group
                label="ピアIPアドレス"
                :value="form.l3.bgp4?.peerIpAddress"
              />
            </v-col>
          </v-row>
          <!-- AS番号 -->
          <v-row>
            <v-col>
              <app-label-group label="AS番号" :value="form.l3.bgp4?.asNumber" />
            </v-col>
          </v-row>
          <!-- MD5キー -->
          <v-row>
            <v-col>
              <app-label-group
                label="MD5キー"
                :value="$filter.emptyTo(form.l3.bgp4?.md5Key, '-')"
              />
            </v-col>
          </v-row>
          <!-- Maximum Prefix -->
          <v-row>
            <v-col>
              <app-label-group
                label="Maximum Prefix"
                :value="form.l3.bgp4?.maximumPrefix"
              />
            </v-col>
          </v-row>
          <!-- Local Preference -->
          <v-row>
            <v-col>
              <app-label-group
                label="Local Preference"
                :value="
                  $filter.enumTo(
                    form.l3.bgp4?.localPreference,
                    'localPreference'
                  )
                "
              />
            </v-col>
          </v-row>
          <!-- MED -->
          <v-row>
            <v-col>
              <app-label-group
                label="MED"
                :value="$filter.enumTo(form.l3.bgp4?.med, 'med')"
              />
            </v-col>
          </v-row>
        </template>

        <!-- ルーティング種別がStaticの場合 -->
        <template v-else>
          <!-- 経路 -->
          <v-row>
            <app-label-group label="経路設定" />
          </v-row>
          <v-row class="ml-1">
            <v-col cols="4">
              <app-label-group>
                <template #label
                  ><span class="text-caption">LANアドレス</span></template
                >
                <template #value>
                  <div v-if="form.l3?.static && form.l3.static.length > 0">
                    <div
                      class="ml-3"
                      v-for="(e, index) in form.l3.static"
                      :key="index"
                    >
                      {{ $filter.emptyTo(e.lanAddress, "-") }}
                    </div>
                  </div>
                  <div v-else class="ml-3">-</div>
                </template>
              </app-label-group>
            </v-col>
            <v-col cols="4">
              <app-label-group>
                <template #label
                  ><span class="text-caption"
                    >ネクストホップアドレス</span
                  ></template
                >
                <template #value>
                  <div v-if="form.l3?.static && form.l3.static.length > 0">
                    <div
                      class="ml-3"
                      v-for="(e, index) in form.l3.static"
                      :key="index"
                    >
                      {{ $filter.emptyTo(e.nextHopAddress, "-") }}
                    </div>
                  </div>
                  <div v-else class="ml-3">-</div>
                </template>
              </app-label-group>
            </v-col>
          </v-row>
        </template>

        <template v-if="isShowQos">
          <!-- QoS設定 -->
          <v-row>
            <v-col>
              <app-label-group
                label="QoS設定"
                :value="
                  form.qos ? $filter.enumTo(form.qos.isQoS, 'on_off') : '-'
                "
              />
            </v-col>
          </v-row>
          <!-- 割当帯域パターン -->
          <v-row v-if="form.qos?.isQoS && qos.qosType === 'BANDWIDTH'">
            <v-col>
              <app-label-group
                label="割当帯域パターン"
                :value="
                  $filter.enumTo(
                    form.qos.qosBandControlPattern,
                    'vnConControlPattern'
                  )
                "
              />
            </v-col>
          </v-row>
        </template>

        <!-- ルーティング種別がBGP4の場合 その2 -->
        <template v-if="form.l3?.routingType === 'BGP4'">
          <!-- 経路集約 -->
          <v-row>
            <v-col>
              <app-label-group
                label="経路集約"
                :value="form.l3.bgp4?.routeAggregation"
              />
            </v-col>
          </v-row>
          <!-- 経路集約アドレス CUSTOM/ON -->
          <v-row>
            <v-col v-if="form.l3.bgp4?.routeAggregation === 'CUSTOM'">
              <app-label-group label="経路集約アドレス">
                <template #value>
                  <div class="d-flex flex-wrap">
                    <span
                      v-for="(e, index) in form.l3.bgp4
                        .routeAggregationAddressList"
                      :key="index"
                      class="ml-3"
                    >
                      {{ e }}
                    </span>
                  </div>
                </template>
              </app-label-group>
            </v-col>
            <v-col v-else-if="form.l3.bgp4?.routeAggregation === 'ON'">
              <app-label-group label="経路集約アドレス" value="0.0.0.0/0" />
            </v-col>
          </v-row>
        </template>

        <!-- DHCPリレー -->
        <v-row>
          <v-col>
            <app-label-group
              label="DHCPリレー"
              :value="form.l3?.enableDhcpRelay ? 'ON' : 'OFF'"
            />
          </v-col>
        </v-row>
        <!-- プライマリサーバ -->
        <v-row>
          <v-col>
            <app-label-group
              label="プライマリサーバ"
              :value="
                form.l3?.enableDhcpRelay && form.l3.dhcpRelay?.primaryAddress
                  ? form.l3.dhcpRelay.primaryAddress
                  : '-'
              "
            />
          </v-col>
        </v-row>
        <!-- セカンダリサーバ -->
        <v-row>
          <v-col>
            <app-label-group
              label="セカンダリサーバ"
              :value="
                form.l3?.enableDhcpRelay && form.l3.dhcpRelay?.secondaryAddress
                  ? form.l3.dhcpRelay.secondaryAddress
                  : '-'
              "
            />
          </v-col>
        </v-row>
      </template>

      <!-- 備考 -->
      <v-row>
        <v-col>
          <app-label-group
            label="備考"
            :value="$filter.emptyTo(form.description, '-')"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { VNConnectForm } from "@/modals/vnConnect/VNConnectEdit.vue";
import type { QosDetail } from "@/apis/QosApi";
import { availablePairLine } from "@/modals/vnConnect/VNConnectEditStepper1.vue";

export default defineComponent({
  name: "VNConnectEditStepper3",
  props: {
    /** true: 編集, false: 追加 */
    isEdit: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    /** Form情報 */
    value: {
      type: Object as PropType<VNConnectForm>,
      required: true,
    },
    /** VPN/VNに紐づくQoS設定詳細 */
    qos: {
      type: Object as PropType<QosDetail>,
      required: true,
    },
  },
  data() {
    return {
      form: this.value,
    };
  },
  computed: {
    /** true: 帯域表示（品目が帯域確保、PF、TF）, false: 非表示 */
    isShowBandwidth(): boolean {
      switch (this.form.bandwidthType) {
        case "BANDWIDTH_SECURED":
        case "PF":
        case "TRAFFICFREE":
          return true;
        case "BURST":
        case "BESTEFFORT":
        default:
          return false;
      }
    },
    /** true: QoS設定を表示（契約変更が可能 & 回線のQoSがON & VPN/VNのQoS設定がON）, false: 非表示 */
    isShowQos(): boolean {
      return (
        this.form.siteInfo!.lineBandwidth?.qos === "ON" &&
        this.qos.qosType !== "NONE"
      );
    },
    /** true: ペア回線表示, false: 非表示 */
    isShowPairLine(): boolean {
      return availablePairLine[this.form.siteInfo!.accessType];
    },
  },
});
</script>
